module.exports = __webpack_public_path__ + "static/media/3.890b07eb.jpg";